import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { WorkDocumentsClass } from './work-documents-class'

export default function WorkDocuments(props) {
  
  const [recruitment, state, groups, urlBase, saving, saved, saveRecruitment, saveRecruitmentInfo, dirtyRecruitment, cleanRecruitment] = useOutletContext()
  return <WorkDocumentsClass {...props} urlBase={urlBase} recruitment={recruitment} onClean={cleanRecruitment} />
}
